import React from 'react';

interface ActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  label?: string;
  colorTheme?: 'primary' | 'teal';
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  onClick,
  disabled = false,
  className = '',
  type = 'button',
  label,
  colorTheme = 'primary',
  ...rest
}) => (
  <div className="relative">
    <label className="block text-sm font-semibold text-text-primary mb-2 sm:mb-3">
      {label}
    </label>
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`w-full text-white rounded-xl sm:rounded-xl py-3 sm:py-4 px-4 sm:px-6 transition-all duration-200 flex items-center justify-center gap-2 sm:gap-3 disabled:cursor-not-allowed hover:shadow-large transform hover:scale-105 disabled:transform-none font-semibold text-sm sm:text-base lg:text-lg ${
        colorTheme === 'primary'
          ? 'bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 disabled:from-primary-400 disabled:to-primary-400 shadow-primary'
          : 'bg-gradient-to-r from-accent-teal-500 to-accent-teal-600 hover:from-accent-teal-600 hover:to-accent-teal-700 disabled:from-accent-teal-400 disabled:to-accent-teal-400 shadow-accent-teal'
      } ${className}`}
      {...rest}
    >
      {children}
    </button>
  </div>
);
